import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default () => {
    'use strict';

    let previousWidth = 0;
    const mobileBreakpoint = 768;

    gsap.registerPlugin(ScrollTrigger);
    let pageScrollTriggers: globalThis.ScrollTrigger[] = [];
    let pageParallax: gsap.core.Timeline[] = [];

    // Fetch user animations' preference cookie
    let animationsPreferenceCookie = getAnimationsPreferenceCookie();

    function getAnimationsPreferenceCookie() {
        return document.cookie
            .split("; ")
            .find((row) => row.startsWith("playAnimations="))
            ?.split("=")[1];
    }

    function animateFrom(elem: any, direction: number = 1) {
        const delay = elem.hasAttribute('data-reveal-delay') ? Number(elem.getAttribute('data-reveal-delay')) : 0;
        const distance = elem.hasAttribute('data-reveal-distance') ? Number(elem.getAttribute('data-reveal-distance')) : 80;
        const type = elem.getAttribute('data-reveal') != '' ? elem.getAttribute('data-reveal') : 'default';

        let x = 0;
        let y = 0;

        if (type == 'default') {
            x = 0;
            y = direction * distance;
        } else if (type == 'fromLeft') {
            x = -distance;
            y = 0;
        } else if (type == 'fromRight') {
            x = distance;
            y = 0;
        }

        gsap.fromTo(elem, { x: x, y: y, autoAlpha: 0 }, {
            duration: 1.25,
            x: 0,
            y: 0,
            autoAlpha: 1,
            delay: delay,
            ease: "expo",
            overwrite: true
        });
    }
    function hideAnimatedElem(elem: any) {
        gsap.set(elem, { autoAlpha: 0 });
    }

    function initAnimations() {
        if (!animationsPreferenceCookie || animationsPreferenceCookie == 'yes') {
            document.body.classList.remove('animations-stopped');

            // On scroll reveals
            gsap.utils.toArray('[data-reveal]').forEach(function (elem: any, index) {
                const isDesktopOnly = elem.hasAttribute('data-reveal-desktop-only');
                if (!isDesktopOnly || window.innerWidth >= mobileBreakpoint) {
                    elem.removeAttribute('data-reveal-show');
                    pageScrollTriggers.push(ScrollTrigger.create({
                        trigger: elem,
                        onEnter: function () {
                            animateFrom(elem)
                        },
                        onLeaveBack: function () {
                            hideAnimatedElem(elem)
                        }
                    }));
                }
            });
            // Parallax
            if (window.innerWidth >= mobileBreakpoint) {
                gsap.utils.toArray('[data-speed]').forEach(function (elem: any) {
                    const offset = elem.hasAttribute('data-offset') ? elem.getAttribute('data-offset') : 0;
                    const block = elem.closest('.block');
                    if (block) {
                        elem.style.top = offset;
                        pageParallax.push(gsap.timeline().to(elem, {
                            y: (i, el) => (-1 * parseFloat(el.getAttribute("data-speed"))) * block.offsetHeight,
                            ease: "none",
                            overwrite: true,
                            scrollTrigger: {
                                trigger: block,
                                scrub: 0,
                                start: 'top bottom',
                            }
                        }));
                    }
                });
            }
        }
    }

    // Stop and kill all animations
    function killAnimations(killScrollReveal = true, killParallax = true) {
        if (killScrollReveal) {
            document.querySelectorAll('[data-reveal]').forEach(el => el.setAttribute('data-reveal-show', ''))
            pageScrollTriggers.forEach(st => {
                st.kill(false);
            });
            pageScrollTriggers = [];
        }

        if (killParallax) {
            document.body.classList.add('animations-stopped');

            pageParallax.forEach(parallaxEl => {
                const parallaxAnim = parallaxEl.getChildren()[0];
                if (parallaxAnim) {
                    parallaxAnim.targets()[0]?.removeAttribute('style');
                    parallaxAnim.revert();
                }
            })
            pageParallax = [];
        }
    }

    // Stop parallax animations on mobile
    function onResize() {
        let actualWindowWidth = window.innerWidth;
        if (actualWindowWidth < mobileBreakpoint && (previousWidth >= mobileBreakpoint || !previousWidth)) {
            // If we hit mobile size for the first time
            killAnimations(false, true);
        } else if (previousWidth < mobileBreakpoint && actualWindowWidth >= mobileBreakpoint) {
            // If we resize from mobile to larger
            initAnimations();
        }
        previousWidth = actualWindowWidth;
    }

    // Init animations if user has not rejected them before
    if (!animationsPreferenceCookie || animationsPreferenceCookie == 'yes') {
        initAnimations();
        onResize();
    } else {
        killAnimations();
    }

    // Event listener on user's animations preferences changes
    const animationsInputs = document.querySelectorAll('input[name="animationsPreferences"]') as NodeListOf<HTMLInputElement>;
    animationsInputs.forEach(inputBtn => {
        // Default animation button state
        inputBtn.checked = !animationsPreferenceCookie || inputBtn.value == animationsPreferenceCookie;

        inputBtn.addEventListener('click', () => {
            // Set user's preferences in animations cookie
            document.cookie = 'playAnimations=' + inputBtn.value + ';path=/; SameSite=Lax; Secure';
            animationsPreferenceCookie = getAnimationsPreferenceCookie();

            // Modify page's animations state
            if (inputBtn.value == 'no') {
                killAnimations();
            } else {
                initAnimations();
            }
        })
    })
    window.onresize = () => onResize();
}
